import React, { useMemo, useRef } from 'react';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import useLineCharts from '@/pages/intelligence/components/Chart/hooks/useLineCharts';
import { showTimeByDateType } from '@/pages/intelligence/utils/commonUtils';
import { RenderType } from '@/pages/intelligence/pages/_config/topchartsInterface';
// 每个榜单，组装好各类可视化需要的数据，传递给可视化统一组件
const Visualis: React.FC<any> = (props: any) => {
  const {
    chartType = ChartType.Line,
    dateType,
    imageType,
    lineData = [], // 折线 数据
    isNodata,
    metric,
    titleNow,
    chartLoading,
    setChartLoading,
    topChartsType,
    renderType,
    segmentList,
    lineSourceName,
  } = props;

  // console.log('Visualis3333', props);
  const cardRef = useRef(null);

  const isPercentLine = useMemo(() => {
    switch (renderType) {
      case RenderType.GROWTH_ONLY:
        return true;
      default:
        return false;
    }
  }, [topChartsType]);

  // 组装rpd折线图数据
  const getRpdTypeData = (list: any, metric = '') => {
    if (!Array.isArray(list) || list?.length < 1) return [];
    const arr: any = [];
    for (const i in list) {
      if (list[i].hasOwnProperty(metric)) {
        arr.push({
          metric,
          time: showTimeByDateType(list[i].date, dateType?.toLocaleLowerCase()),
          value: list[i][metric].this,
        });
      }
    }
    return arr;
  };

  const getMetricsList = (list: any, segment: string) => {
    if (!Array.isArray(list) || list?.length < 1) return [];
    const arr: any = [];
    const objTemp = {
      id: segment,
      name: titleNow,
      history: getRpdTypeData(list || [], segment),
    };
    arr.push(objTemp);
    return arr;
  };

  const lineSeriesData = useMemo(() => {
    const arrGameData: any = {};
    for (const n in segmentList) {
      arrGameData[segmentList[n].value] = getMetricsList(lineData, segmentList[n].value);
    }
    return arrGameData;
  }, [lineData, metric, dateType]);

  // 获取折线图hooks
  const { lineOption } = useLineCharts({
    lineData: lineSeriesData,
    metric,
    topChartsType: 'pcconsole-stats-line',
    imageType,
    titleNow,
    chartType,
    setChartLoading,
    dateType,
    isPercentLine,
    lineSourceName,
  });

  return (
    <>
      <div className="card-line" ref={cardRef}>
        <ChartsIndex
          chartLoading={chartLoading}
          lineOption={lineOption}
          chartType={chartType}
          isNodata={isNodata}
        />
      </div>
    </>
  );
};

export default Visualis;
